import React, { ReactNode, useState, useEffect } from 'react';
import Header from './Header';
import { useProductMatrix } from '../contexts/ProductMatrixContext';

type LayoutProps = {
  children: ReactNode;
}

function Layout({ children }: LayoutProps) {
  const { isAIDrawerOpen, aiDrawerWidth, isDisclaimerDismissed } = useProductMatrix();
  const [isDesktop, setIsDesktop] = useState(false);

  // Detect desktop screen size
  useEffect(() => {
    const checkDesktop = () => {
      setIsDesktop(window.innerWidth >= 1024); // lg breakpoint
    };

    checkDesktop();
    window.addEventListener('resize', checkDesktop);
    return () => window.removeEventListener('resize', checkDesktop);
  }, []);

  const aiPanelWidth = isDesktop && isAIDrawerOpen ? aiDrawerWidth : 0;

  return (
    <div className="min-h-screen bg-background">
      {/* Persistent Header */}
      <Header isAIOpen={isDesktop && isAIDrawerOpen} aiPanelWidth={aiPanelWidth} />

      {/* Main Content with proper padding to prevent header and disclaimer overlap */}
      <main className={isDisclaimerDismissed ? 'pt-[58px]' : 'pt-[112px]'}>{children}</main>
    </div>
  );
};

export default Layout;
